var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFishFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1535_1509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9067 7.64931C14.6181 5.39834 12.2195 4.00006 9.64711 4.00006C7.37781 4.00006 5.24444 5.08861 3.8884 6.89022L1.20508 4.20679C1.10636 4.10805 0.980581 4.0408 0.843641 4.01355C0.706702 3.98631 0.564757 4.00028 0.43576 4.05371C0.306764 4.10714 0.19651 4.19763 0.118944 4.31372C0.0413787 4.42982 -1.46059e-05 4.56631 3.86607e-09 4.70594V11.2942C6.55072e-06 11.4338 0.0414113 11.5703 0.118978 11.6863C0.196546 11.8024 0.306791 11.8929 0.435775 11.9463C0.564758 11.9997 0.706686 12.0137 0.843612 11.9865C0.980537 11.9592 1.10631 11.892 1.20503 11.7933L3.88834 9.10995C5.24433 10.9116 7.37775 12.0001 9.64706 12.0001C12.2196 12.0001 14.6182 10.6017 15.9068 8.35075C15.9679 8.24396 16 8.12306 16 8.00002C16 7.87698 15.9679 7.75609 15.9067 7.64931Z",
    fill: "#2EA8CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1535_1509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishFilled);
export default __webpack_public_path__ + "static/media/fish-filled.8cf568cfdd936e4f3f8cf0540d205013.svg";
export { ForwardRef as ReactComponent };